import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ITableInputWidget } from './ITableInputWidget';
import { TableInputContainer } from './render/TableInputContainer';

export interface ITableInputWidgetProps
  extends IWidgetComponentProps<ITableInputWidget> {}

export function TableInputWidgetComponent(props: ITableInputWidgetProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <TableInputContainer {...props} options={options}>
      {props.children}
    </TableInputContainer>
  );
}
